// const userFormsUrl = SHIFU_SERVICE_API_PREFIX + "/v1/user/details?userId=$userId";
// const postUserFormUrl = SHIFU_SERVICE_API_PREFIX + "/v1/user/save-details?userId=$userId&formId=$formId";
// const skillsByCategory = SHIFU_SERVICE_API_PREFIX + "/v1/pillar/search?query=tenant.eq:$tenant";
// const actionsBySkill = SHIFU_SERVICE_API_PREFIX + "/v1/action/search?query=skillId.eq:$skillId";
// const anchorSearch = SHIFU_SERVICE_API_PREFIX + "/v1/anchor/search?query=tenant.eq:$tenant";
// const celebrationSearch = SHIFU_SERVICE_API_PREFIX + "/v1/celebration/search";
//
// const pastCheckins = SHIFU_SERVICE_API_PREFIX + "/v1/userCheckIn/$userId/history";
// const lastCheckin = SHIFU_SERVICE_API_PREFIX + "/v1/userCheckIn/$userId/last?tenant=$tenant";
//
// const saveCheckin = SHIFU_SERVICE_API_PREFIX + "/v1/userCheckIn";
// const saveDraftCheckin = SHIFU_SERVICE_API_PREFIX + "/v1/checkInDraft/save";
// const getInputTypesForCheckin = SHIFU_SERVICE_API_PREFIX + "/v1/inputType/search";
// const getWODFilters = SHIFU_SERVICE_API_PREFIX + "/v1/wod/filters";
// const getLiveClassesFilters = SHIFU_SERVICE_API_PREFIX + "/v1/liveClass/filters";
// const getWODsList = SHIFU_SERVICE_API_PREFIX + "/v1/microcycle/managed/search/tenantId/2";
// const fetchUserActivityUrl =
// 	SHIFU_SERVICE_API_PREFIX + "/v1/user_activity/progress/weekly?fromEpochDate=$fromEpochDate&toEpochDate=$toEpochDate&userId=$userId&tenant=$tenant&skipNewActions=false&calculateStreak=true";
// const fetchUserActivityHistoryUrl = SHIFU_SERVICE_API_PREFIX + "/v1/user_activity/progress/all?userId=$userId&tenant=$tenant&skipUserAction=false";
// const fetchUserActivitySummary = SHIFU_SERVICE_API_PREFIX + "/v1/user_activity/progress/summary";
//
// const searchGoalsFamiliesUrl = SHIFU_SERVICE_API_PREFIX + "/v1/goal-families/search?query=tenant.eq:$tenant";
// const saveGoalsUrl = SHIFU_SERVICE_API_PREFIX + "/v1/user-goals/$userId/save";
// const expireUserGoalUrl = SHIFU_SERVICE_API_PREFIX + "/v1/user-goals/expire";
// const getUserActiveGoalsUrl = SHIFU_SERVICE_API_PREFIX + "/v1/user-goals/$userId/active?tenant=$tenant";
// const getUserGoalSummaryUrl = SHIFU_SERVICE_API_PREFIX + "/v1/user-goal-summary/$userId/?tenant=$tenant";
//
// const fetchWhatsAppNotification = SHIFU_SERVICE_API_PREFIX + "/v1/userPreference/search?limit=100&offset=0&query=userId.eq:$userId;tenant.eq:$tenant&sortOrder=ASC";
// const createWhatsAppNotification = SHIFU_SERVICE_API_PREFIX + "/v1/userPreference/";
// const patchWhatsAppNotification = SHIFU_SERVICE_API_PREFIX + "/v1/userPreference/$Id";
//
import {
	ICreateTaskRequest,
	IDisposeTaskRequest,
	IFetchPermittedDispositionsParams,
	IFetchPermittedDispositionsRes,
	IFilterTasksParams,
	ITaskCategory,
	IValidateTaskDisposalResponse,
} from "../../interfaces/ITask"

// const filterTasksUrl = SHIFU_SERVICE_API_PREFIX + "/v1/task/filterV2";
// const createTask = SHIFU_SERVICE_API_PREFIX + "/v1/task-schedule/create/bulk";
// const disposeTask = SHIFU_SERVICE_API_PREFIX + "/v1/task/$id";
// const countTasksByStatusUrl = SHIFU_SERVICE_API_PREFIX + "/v1/task/count-by-status";
// const validateTaskDisposalUrl = SHIFU_SERVICE_API_PREFIX + "/v1/task/status-update/permitted-disposition?taskId=$taskId&taskStatus=$taskStatus&dispositionStatus=$dispositionStatus";
// const taskCategorySearchUrl = SHIFU_SERVICE_API_PREFIX + "/v1/task-category/search?limit=100&offset=0&sortBy=NULL&sortOrder=ASC";
// const fetchPermittedDispositionsUrl = ({ tenant, userId }: IFetchPermittedDispositionsParams) => SHIFU_SERVICE_API_PREFIX + `/v1/task-disposition/user/permitted?tenant=${tenant}&userId=${userId}`;
import { IShifuServiceApis } from "./IShifuServiceApis"
import { AppTenants } from "../../constants"
import ApiUtils from "../ApiUtils"
import { PaginatedResponseMini } from "../../interfaces/baseInterfaces"
import { get, set } from "lodash"
import { getPatientTenant } from "../../utils/helpers"
import { IInterventionUserActivityProgress, IInterventionUserActivityResponse, IInterventionUserActivitySummary } from "../../interfaces/patient/IPatientInterventions"
import { IGoalsFamilyResponse, IPatientActiveGoalsResponse, IUserGoalSummaryResponse, IPatientGoal } from "../../interfaces/patient/IPatientGoals"

const ShifuUrl = {
	filterUrl: "/v1/task/filterV2",
	searchTaskCategory: "/v1/task-category/search?limit=100&offset=0&sortBy=NULL&sortOrder=ASC",
	validateTaskDisposal: (taskId: number, taskStatus: string, dispositionStatus: string) =>
		`/v1/task/status-update/permitted-disposition?taskId=${taskId}&taskStatus=${taskStatus}&dispositionStatus=${dispositionStatus}`,
	createTask: "/v1/task-schedule/create/bulk",
	disposeTask: (taskId: string) => `/v1/task/${taskId}`,
	fetchPermittedDisposition: (tenant: AppTenants, userId: number) => `/v1/task-disposition/user/permitted?tenant=${tenant}&userId=${userId}`,
	userActivitySummary: `/v1/user_activity/progress/summary`,
	userActiveGoals: (userId: string, tenant: string) => `/v1/user-goals/${userId}/active?tenant=${tenant}`,
	getUserGoalSummaryUrl: (userId: string, tenant: string) => `/v1/user-goal-summary/${userId}/?tenant=${tenant}`,
	saveCheckIn: `/v1/userCheckIn`,
	saveGoals: (userId: string) => `/v1/user-goals/${userId}/save`,
	expireUserGoals: `/v1/user-goals/expire`,
	searchAnchor: (tenant: string) => `/v1/anchor/search?query=tenant.eq:${tenant}`,
	skillByCategory: (tenant: string) => `/v1/pillar/search?query=tenant.eq:${tenant}`,
	lastCheckin: (userId: string, tenant: string) => `/v1/userCheckIn/${userId}/last?tenant=${tenant}`,
	liveClassFilters: `/v1/liveClass/filters`,
	searchGoalFamilies: (tenant: string, userId: string) => `/v1/goal-families/search/v2?query=tenant.eq:${tenant}&userId=${userId}`,
	userAutomatedGoals: (userId: string) => `/v1/user-goal/auto-create?userId=${userId}`,
	userActivities: (fromEpochDate: number, toEpochDate: number, userId: string, tenant: string) =>
		`/v1/user_activity/progress/weekly?fromEpochDate=${fromEpochDate}&toEpochDate=${toEpochDate}&userId=${userId}&tenant=${tenant}&skipNewActions=false&calculateStreak=true`,
	userActivityHistory: (userId: string, tenant: string) => `/v1/user_activity/progress/all?userId=${userId}&tenant=${tenant}&skipUserAction=false`,
}
export default class ShifuServiceApis implements IShifuServiceApis {
	getServiceUrl = (url: string) => "/shifu" + url
	// fetchUserForms(userId: string): Promise<any> {
	// 	const url = userFormsUrl.replace("$userId", userId);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// postUserForm(userId: string, formId: string, formData: any): Promise<any> {
	// 	const url = postUserFormUrl.replace("$userId", userId).replace("$formId", formId);
	// 	return ApiUtils.apiPutRequest(url, JSON.stringify(formData));
	// }
	//
	fetchSkillsByCategory() {
		return ApiUtils.get(this.getServiceUrl(ShifuUrl.skillByCategory(getPatientTenant())))
	}
	//
	// fetchActionsforSkills(skillId: number) {
	// 	const url = actionsBySkill.replace("$skillId", skillId.toString());
	// 	return ApiUtils.apiGetRequest(url);
	// }
	fetchAnchors() {
		return ApiUtils.get(this.getServiceUrl(ShifuUrl.searchAnchor(getPatientTenant())))
	}
	// fetchCelebrationsForActions() {
	// 	return ApiUtils.apiGetRequest(celebrationSearch);
	// }
	// fetchPastCheckins(userId: string): Promise<any> {
	// 	const url = pastCheckins.replace("$userId", userId);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	fetchLastCheckin(userId: string): Promise<any> {
		return ApiUtils.get(this.getServiceUrl(ShifuUrl.lastCheckin(userId, getPatientTenant())))
	}
	saveCheckin(payload: any): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(ShifuUrl.saveCheckIn), payload)
	}
	// saveDraftCheckin(payload: any): Promise<any> {
	// 	return ApiUtils.apiPostRequest(saveDraftCheckin, JSON.stringify(payload));
	// }
	//
	// getInputTypesForCheckin(): Promise<any> {
	// 	return ApiUtils.apiGetRequest(getInputTypesForCheckin);
	// }
	// getWODFilterTypes(): Promise<any> {
	// 	return ApiUtils.apiGetRequest(getWODFilters);
	// }
	getLiveClassesFilterTypes(): Promise<any> {
		return ApiUtils.get(this.getServiceUrl(ShifuUrl.liveClassFilters))
	}
	//
	fetchUserActivities(fromEpochDate: number, toEpochDate: number, userId: string): Promise<IInterventionUserActivityResponse> {
		const url = this.getServiceUrl(ShifuUrl.userActivities(fromEpochDate, toEpochDate, userId, getPatientTenant()))
		return ApiUtils.get(url)
	}

	fetchUserActivityHistory(userId: string): Promise<IInterventionUserActivityProgress[]> {
		return ApiUtils.get(this.getServiceUrl(ShifuUrl.userActivityHistory(userId, getPatientTenant())))
	}

	fetchUserActivitySummary(userId: string, type: string, fromEpochDate?: number, toEpochDate?: number): Promise<IInterventionUserActivitySummary> {
		const queryParams = ApiUtils.requestToQueryParams({
			userId,
			type,
			fromEpochDate,
			toEpochDate,
			tenant: getPatientTenant(),
		})
		return ApiUtils.get(this.getServiceUrl(`${ShifuUrl.userActivitySummary}?${queryParams}`))
	}

	fetchGoalsFamilies(userId: string): Promise<IGoalsFamilyResponse> {
		return ApiUtils.get(this.getServiceUrl(ShifuUrl.searchGoalFamilies(getPatientTenant(), userId)))
	}

	saveGoals(payload: IPatientGoal[], userId: string): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(ShifuUrl.saveGoals(userId)), payload)
	}
	//
	expireUserGoal(payload: { userGoalIds: string[] }): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(ShifuUrl.expireUserGoals), payload)
	}

	getUserActiveGoals(userId: string): Promise<IPatientActiveGoalsResponse[]> {
		return ApiUtils.get(this.getServiceUrl(ShifuUrl.userActiveGoals(userId, getPatientTenant())))
	}
	//
	getUserGoalSummary(userId: string): Promise<IUserGoalSummaryResponse> {
		const url = this.getServiceUrl(ShifuUrl.getUserGoalSummaryUrl(userId, getPatientTenant()))
		return ApiUtils.get(url)
	}
	// fetchWhatsAppNotification(userId: number): Promise<ISetting> {
	// 	const url = fetchWhatsAppNotification.replace("$userId", userId.toString()).replace("$tenant", AppUtils.getPatientTenant);
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	// createWhatsAppNotification(notify_data: INotifyData): Promise<IPreference> {
	// 	const url = createWhatsAppNotification;
	// 	return ApiUtils.apiPostRequest(url, JSON.stringify(notify_data));
	// }
	//
	// patchWhatsAppNotification(id: number, notify_data: INotifyData): Promise<IPreference> {
	// 	const url = patchWhatsAppNotification.replace("$Id", id.toString());
	// 	return ApiUtils.apiPutRequest(url, JSON.stringify(notify_data));
	// }
	//
	filterTasks(params: IFilterTasksParams) {
		const payload: IFilterTasksParams = { ...params }
		if (!params.tenant || ![AppTenants.SUGARFIT, AppTenants.ULTRAFIT].includes(params.tenant)) {
			payload.tenant = AppTenants.SUGARFIT
		}
		const queryParams = new URLSearchParams(Object.entries(payload)).toString()
		const url = this.getServiceUrl(`${ShifuUrl.filterUrl}?${queryParams}`)
		return ApiUtils.get(url)
	}
	//
	createTask(payload: ICreateTaskRequest) {
		const url = this.getServiceUrl(ShifuUrl.createTask)
		const updatedPayload: ICreateTaskRequest = { ...payload }
		if (!get(payload, "taskScheduleEntry.tenant")) {
			set(updatedPayload, "taskScheduleEntry.tenant", AppTenants.SUGARFIT)
		}
		return ApiUtils.post(url, updatedPayload)
	}
	//
	disposeTask(taskId: string, payload: IDisposeTaskRequest, status?: string) {
		const url = this.getServiceUrl(ShifuUrl.disposeTask(taskId))
		const updatedPayload = { ...payload, status: status || "COMPLETED", id: taskId }
		if (!payload.tenant) {
			updatedPayload.tenant = AppTenants.SUGARFIT
		}
		return ApiUtils.patch(url, updatedPayload)
	}
	//
	// countTasksByStatus(params: ICountTasksByStatusRequest): Promise<ICountTasksByStatusResponse> {
	// 	const payload: ICountTasksByStatusRequest = { ...params };
	// 	if (!params.tenant) {
	// 		payload.tenant = APP_TENANTS.SUGARFIT;
	// 	}
	// 	const queryParams = new URLSearchParams(Object.entries(payload)).toString();
	// 	const url = `${countTasksByStatusUrl}?${queryParams}`;
	// 	return ApiUtils.apiGetRequest(url);
	// }
	//
	getAllTaskCategories(): Promise<PaginatedResponseMini<ITaskCategory>> {
		return ApiUtils.get(this.getServiceUrl(ShifuUrl.searchTaskCategory))
	}

	validateTaskDisposal(taskId: number, taskStatus: string, dispositionStatus: string): Promise<IValidateTaskDisposalResponse> {
		const url = this.getServiceUrl(ShifuUrl.validateTaskDisposal(taskId, taskStatus, dispositionStatus))
		return ApiUtils.get(url)
	}

	fetchPermittedDispostions(payload: IFetchPermittedDispositionsParams): Promise<IFetchPermittedDispositionsRes[]> {
		const tenant = [AppTenants.ULTRAFIT, AppTenants.SUGARFIT].includes(payload.tenant) ? payload.tenant : AppTenants.SUGARFIT
		const url = this.getServiceUrl(ShifuUrl.fetchPermittedDisposition(tenant, payload.userId))
		return ApiUtils.get(url)
	}

	fetchUserAutomatedGoals(userId: string): Promise<any> {
		const url = this.getServiceUrl(ShifuUrl.userAutomatedGoals(userId))
		return ApiUtils.get(url)
	}
}
